<template>
  <div class="c-upload-image">
    <h4>{{title}}</h4>

    <!-- optional guidance, only rendered when `recommended` is passed -->
    <div v-if="recommended" class="c-upload-image-specs">
      <span class="c-upload-image-chip c-upload-image-chip--size">{{ recommended.size }}</span>
      <span class="c-upload-image-chip c-upload-image-chip--ratio">Ratio {{ recommended.ratio }}</span>
      <span class="c-upload-image-chip">JPG · PNG · AVIF</span>
      <p class="c-upload-image-specs__note">
        Best size. A bigger image works too, as long as it keeps the same shape (ratio {{ recommended.ratio }}).
      </p>
    </div>

    <img
      v-if="image_url || !recommended"
      class="c-upload-image-preview"
      :src="image_url ? image_url : '/img/stub.jpg'"
      alt="landing page logo"/>
    <div
      v-else
      class="c-upload-image-placeholder"
      :style="{ aspectRatio: recommended.aspect }">
      <i class="fa-regular fa-image"></i>
      <strong>{{ recommended.size }}</strong>
      <span>Ratio {{ recommended.ratio }} · {{ recommended.shape }}</span>
    </div>

    <div class="c-upload-image-wrapper">
      <c-upload
        :id="id || `upload-${uuid}`"
        :uuid="uuid"
        buttonText="Choose an Image"
        data-images-only="true"
        :existing-images="existingImages"
        :existingImagesUrl="existingImagesUrl"
        @onSuccess="(file) => $emit('upload', file)"
        :allowed-extensions="allowedExtensions"
        :max-size-mb="maxSizeMb"
        :data-crop="dataCrop"
      />

      <c-button
        v-if="image_url"
        theme="danger"
        size="md"
        icon="fa-trash-can"
        @click="$emit('remove')"
      >Delete</c-button>
    </div>

    <div>
        <span class="help-block">
         {{helpText}}
        </span>
    </div>

    <slot />
  </div>
</template>

<style lang="scss">
.c-upload-image{
  border: 1px solid #eee;
  padding: 1px 10px;
  border-radius: 8px;
  width: auto;
  margin-bottom: 30px;

}

.c-upload-image-wrapper{
  display: grid;
  grid-template-columns: auto auto;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  padding-top: 20px;

  .form-group{
    margin-bottom: 0;
    margin-top: 0;
  }
}

.c-upload-image-preview{
  max-width: 200px;
  max-height: 200px;
  object-fit: contain;
  width: 100%;
  height: 200px;
  //max-height: 200px;
}

.c-upload-image-specs {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 4px 0 14px;

  &__note {
    color: #718096;
    flex-basis: 100%;
    font-size: 12px;
    line-height: 1.4;
    margin: 4px 0 0;
  }
}

.c-upload-image-chip {
  background: #f8f9fb;
  border: 1px solid #e4e8ed;
  border-radius: 999px;
  color: #4a5568;
  font-size: 12px;
  line-height: 1;
  padding: 6px 10px;

  &--size {
    background: #eef4ff;
    border-color: #c9dbff;
    color: #1d4ed8;
    font-weight: 600;
  }

  &--ratio {
    background: #f3f0ff;
    border-color: #ddd6fe;
    color: #5b21b6;
  }
}

// empty state: a dashed frame in the real proportions of the slot
.c-upload-image-placeholder {
  align-items: center;
  background: #f8f9fb;
  border: 2px dashed #cbd5e1;
  border-radius: 6px;
  color: #718096;
  display: flex;
  flex-direction: column;
  gap: 2px;
  justify-content: center;
  margin-bottom: 10px;
  max-width: 360px;
  width: 100%;

  i {
    color: #a0aec0;
    font-size: 22px;
    margin-bottom: 4px;
  }

  strong {
    color: #4a5568;
    font-size: 15px;
  }

  span {
    font-size: 12px;
  }
}
</style>

<script>
export default {
  // recommended: { size: '1265 × 530 px', ratio: '12 : 5', aspect: '1265 / 530', shape: 'wide banner' }
  props:['title', 'image_url', 'helpText', 'uuid', 'existingImages', 'existingImagesUrl', 'id', 'dataCrop', 'allowedExtensions', 'maxSizeMb', 'recommended'],
  methods: {

  },
}
</script>